import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';

import COL_NAME_TOKEN from './constants/table-col-name-token.constant';
import { TableCol } from './interfaces/table-col.interface';
import { TableRowAction } from './interfaces/table-row-action.interface';

const DEFAULT_LOADING_ROWS = 3;

@Component({
    selector: 'mapp-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class TableComponent<T> implements OnChanges, OnInit {
    @Input() cols: TableCol[];

    @Input() rows: T[];

    @Input() actions: TableRowAction[];

    @Input() loadingRowsQuantity = DEFAULT_LOADING_ROWS;

    @Output() reorder: EventEmitter<TableCol> = new EventEmitter();

    @Output() rowAction: EventEmitter<{ action: string; data: T }> = new EventEmitter();

    loadingRows = [];

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loadingRowsQuantity?.currentValue) {
            this.setLoadingRows(changes.loadingRowsQuantity.currentValue);
        }
    }

    /**
     *
     */
    ngOnInit(): void {
        this.setLoadingRows(this.loadingRowsQuantity || DEFAULT_LOADING_ROWS);
    }

    /**
     *
     * @param col
     */

    /**
     *
     * @param col
     */

    /**
     *
     * @param col
     */
    onClickOrder(col: TableCol) {
        this.cols.forEach((item) => {
            if (item.name === col.name) {
                item.selected = true;
                item.sortDirection = item.sortDirection === 1 ? -1 : 1;
            } else {
                item.selected = false;
                item.sortDirection = 1;
            }
        });

        this.reorder.emit(col);
    }

    /**
     *
     * @param actionName
     * @param row
     */
    handleColAction(actionName: string, row: T) {
        this.rowAction.emit({
            action: actionName,
            data: row,
        });
    }

    /**
     *
     * @param col
     */

    /**
     *
     * @param col
     */
    customTemplate(col: TableCol) {
        return col.config.component;
    }

    /**
     *
     * @param col
     * @param row
     */

    /**
     *
     * @param col
     * @param row
     */
    customInjector(col: TableCol, row: T) {
        const inputs = {};

        Object.keys(col.config.inputs).forEach((key) => {
            const inputValue = col.config.inputs[key];

            if (inputValue === COL_NAME_TOKEN) {
                inputs[key] = row[col.name];
            }

            if (typeof inputValue === 'function') {
                inputs[key] = (inputValue as CallableFunction)(row);
            }

            if (inputValue !== COL_NAME_TOKEN && typeof inputValue !== 'function') {
                inputs[key] = inputValue;
            }
        });

        return Injector.create({
            providers: [{ provide: col.config.inputsToken, useValue: inputs }],
        });
    }

    /**
     *
     * @param quantity
     */
    private setLoadingRows(quantity: number) {
        this.loadingRows = [];

        for (let i = 1; i <= quantity; i++) {
            this.loadingRows.push(i);
        }
    }

    /**
     *
     * @param iconName
     */
    getIconPath(iconName: string): string {
        return `/assets/icons/${iconName}.svg`;
    }
}
